import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { downloadPoller as downloadConversion } from '@api/downloading/download_poller';
import { defaultAttachment, defaultCroppedData } from './helper';


const DownloadButton = ({
  attachment,
  croppedData,
  fixedDimensions,
  imageToThumbnailRatio,
  selectedFiletype,
  selectedPreset,
  handleDownloadLink,
}) => {
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const [storedTimeouts, setStoredTimeouts] = useState([]);

  useEffect(() => (() => storedTimeouts.forEach((timeout) => clearTimeout(timeout))), []);

  const handleDownload = () => {
    setIsDownloadDisabled(true);
    setStoredTimeouts((prevState) => {
      const timeouts = prevState ? [...prevState] : [];
      timeouts.push(setTimeout(() => setIsDownloadDisabled(false), 4000));
    });

    const { height, width, x, y } = croppedData;
    const downloadParams = {
      crop_gravity: 'north_west',
      crop_width: Math.round(width * imageToThumbnailRatio),
      crop_height: Math.round(height * imageToThumbnailRatio),
      crop_x_offset: Math.round(x * imageToThumbnailRatio),
      crop_y_offset: Math.round(y * imageToThumbnailRatio),
    };

    if (fixedDimensions) {
      const { height: presetHeight, width: presetWidth } = selectedPreset.value;
      downloadParams.width = presetWidth;
      downloadParams.height = presetHeight;
    } else {
      // provide width and height so conversion doesn't default to original image dimensions
      downloadParams.width = downloadParams.crop_width;
      downloadParams.height = downloadParams.crop_height;
    }

    const attachment_key = attachment.id;
    const extension = selectedFiletype || 'PNG';
    const pollerUrl = `/${BF.fx.brandfolder().slug}/attachments/${attachment_key}/poller`;
    const params = { dl: true, extension, ...downloadParams };
    if (handleDownloadLink) {
      // when you want link returned to parent component instead of download
      handleDownloadLink(params);
    } else {
      downloadConversion(pollerUrl, { params }, 500);
    }
  };

  return (
    <React.Fragment>
      <button
        className="button primary download-button md"
        disabled={isDownloadDisabled}
        onClick={handleDownload}
        type="button"
      >
        {handleDownloadLink ? t('Use Image') : t('Download')}
      </button>
    </React.Fragment>
  );
};

DownloadButton.propTypes = {
  attachment: PropTypes.shape({
    attributes: PropTypes.shape({
      filename: PropTypes.string,
      height: PropTypes.number,
      size: PropTypes.number,
      width: PropTypes.number,
    })
  }),
  croppedData: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  fixedDimensions: PropTypes.bool.isRequired,
  imageToThumbnailRatio: PropTypes.number.isRequired,
  selectedFiletype: PropTypes.string.isRequired,
  selectedPreset: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      aspect_ratio: PropTypes.number,
      height: PropTypes.number,
      width: PropTypes.number,
      format: PropTypes.string,
      pad: PropTypes.bool,
      crop_gravity: PropTypes.string,
    }),
  }),
  handleDownloadLink: PropTypes.func,
};

DownloadButton.defaultProps = {
  attachment: defaultAttachment,
  croppedData: defaultCroppedData,
  selectedPreset: null,
  handleDownloadLink: null
};

export default DownloadButton;
